import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapCollection } from './normalize'
import type { MetricEvent } from '../../types/apiModels'

export const getMetricsByPaddockId = async ({
  paddockId,
  signal,
}: {
  paddockId: string
  signal?: AbortSignal
}): Promise<MetricEvent[]> => {
  const response = await apiClient.get(endpoints.metricsByPaddockId, {
    params: { id: paddockId },
    signal,
  })
  return unwrapCollection<MetricEvent>(response)
}
